import React, { useEffect, useState } from "react";
import Footer from './Footer';
import FloatingButtons from '../FloatingButtons';
import Header from "./Header";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { LOGOMAIN, VLOGO } from "../../utils/helper";

function Layout({ children }) {
    const [logo,setLogo] = useState({"logo":LOGOMAIN,"width":"w-40"});
    const location = useLocation();
    useEffect(()=>{
        if (location.pathname == '/vedikshha') {
            setLogo({logo:VLOGO,width:"w-20"});
        }
    },[location])
    
    
    // const setting = useSelector((state) => state?.globalState?.siteSetting?.site_settings);
  

    return (
        <div className="min-h-screen bg-gray-50">
            <Header LOGOMAIN={logo.logo}  width={logo.width} />

            <div>
                {children}
            </div>

                <Footer/>
            <FloatingButtons whatsapp="+91 9175612798"/>
        </div>
    );
}

export default Layout;